webpackJsonp([1],{

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(70)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(263),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(262),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(68)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(261),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(265),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(264),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-slide-x-transition', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "raised": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "src": "/static/img/paisaje.jpg",
      "height": "300px"
    }
  }, [_c('v-layout', {
    staticClass: "media",
    attrs: {
      "column": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-card-title', {
    staticClass: "white--text pl-5 pt-5"
  }, [_c('div', {
    staticClass: "display-1 pl-5 pt-5"
  }, [_vm._v("Jose Ángel Hermosilla Rodrigo")])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://github.com/joseahr",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://stackoverflow.com/users/3866134/jose-hermosilla-rodrigo?tab=profile",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-stack-overflow fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.facebook.com/jose.hermosillarodrigo",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.instagram.com/josehermosillarodrigo/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.linkedin.com/in/jose-%C3%A1ngel-hermosilla-rodrigo-70a590147/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x"
  })])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "indigo"
    }
  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("joherro123@gmail.com")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Personal")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("joherro3@topo.upv.es")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Universidad")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "indigo"
    }
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("España")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Torrent, Valencia 46900")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _vm._l((_vm.estudios), function(estudio) {
    return _c('v-list-tile', {
      key: estudio.title,
      attrs: {
        "three-lines": ""
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-action', [(estudio.icon) ? _c('v-icon', {
      attrs: {
        "color": "indigo"
      }
    }, [_vm._v(_vm._s(estudio.icon))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(estudio.title)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(estudio.centro)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(estudio.periodo)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-divider')], 2), _vm._v(" "), _c('v-card-text', [_c('b', [_vm._v("Conocimientos")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, _vm._l((_vm.conocimientos), function(conocimiento) {
    return _c('v-chip', {
      key: conocimiento,
      attrs: {
        "color": "primary",
        "text-color": "white"
      }
    }, [_vm._v(_vm._s(conocimiento))])
  })), _vm._v(" "), _c('b', [_vm._v("Tecnologías Usadas")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, _vm._l((_vm.tecnologias), function(tecnologia) {
    return _c('v-chip', {
      key: tecnologia,
      attrs: {
        "color": "primary",
        "text-color": "white"
      }
    }, [_vm._v(_vm._s(tecnologia))])
  })), _vm._v(" "), _c('b', [_vm._v("StackOverflow")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('a', {
    attrs: {
      "href": "https://stackexchange.com/users/4785502"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://stackexchange.com/users/flair/4785502.png",
      "width": "208",
      "height": "58",
      "alt": "profile for Jose Hermosilla Rodrigo on Stack Exchange, a network of free, community-driven Q&A sites",
      "title": "profile for Jose Hermosilla Rodrigo on Stack Exchange, a network of free, community-driven Q&A sites"
    }
  })])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "primary ma-1 mt-2"
  }, [_c('v-card-title', {
    staticClass: "text-xs-center"
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs12": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.repos.length) + " Proyectos")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.repos), function(repo) {
    return _c('v-layout', {
      key: repo.id,
      staticClass: "ma-1 mb-2",
      attrs: {
        "xs10": "",
        "offset-xs1": "",
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', [_c('v-toolbar', {
      attrs: {
        "card": "",
        "color": "white"
      }
    }, [_c('v-toolbar-title', {
      staticClass: "body-2 grey--text"
    }, [_vm._v(_vm._s(repo.name))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" " + _vm._s(repo.stargazers_count) + "\n          "), _c('i', {
      staticClass: "fa fa-code-fork"
    }), _vm._v(" " + _vm._s(repo.forks) + "\n          "), _c('i', {
      staticClass: "fa fa-bug"
    }), _vm._v(" " + _vm._s(repo.open_issues_count) + "\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "to": ("portfolio/" + (repo.name)),
        "target": "__blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("content_paste")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "href": repo.html_url,
        "target": "__blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("send")])], 1)], 1)], 1)], 1)], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "id": "scroll-0",
      "fluid": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.notFound) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "id": "md-container"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.markdown)
    }
  }) : _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Repositorio sin README =(")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.fab),
      expression: "fab"
    }],
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": _vm.toTop
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }],
    attrs: {
      "light": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "z-index": "2",
      "position": "absolute",
      "width": "100vw",
      "height": "100vh"
    },
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('h2', {
    staticClass: "white--text"
  }, [_vm._v("J. Hermosilla")]), _vm._v(" "), _c('h4', {
    staticClass: "white--text bold--text pa-2",
    staticStyle: {
      "background": "rgba(0,0,0,0.5)"
    }
  }, [_vm._v("GIS & Web Mapping!")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100vw",
      "height": "100vh"
    },
    attrs: {
      "id": "banner-welcome"
    }
  }, [_c('v-parallax', {
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "jumbotron": "",
      "src": "/static/img/paisaje.jpg"
    }
  })], 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "color": "grey lighten-5 primary",
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-scale-transition', [_c('v-card', {
    staticClass: "card--flex-toolbar"
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "color": "white",
      "prominent": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "body-2 grey--text"
  }, [_c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": "48px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/joseahr.jpg",
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Jose Ángel Hermosilla Rodrigo")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('h5', {
    staticClass: "primary--text"
  }, [_vm._v("¡Bienvenido!")]), _vm._v(" "), _c('p', [_vm._v("Me llamo Jose Ángel y soy Ingeniero en Geomática y Topografía.")]), _vm._v(" "), _c('p', [_vm._v("Gracias a mi formación soy experto en diversas materias como: Geodesia, SIG, IDEs, Web Mapping...")]), _vm._v(" "), _c('p', [_vm._v("Me apasiona la programación y aprendo cada día de las nuevas tecnologías.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://github.com/joseahr",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://stackoverflow.com/users/3866134/jose-hermosilla-rodrigo?tab=profile",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-stack-overflow fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.facebook.com/jose.hermosillarodrigo",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.instagram.com/josehermosillarodrigo/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.linkedin.com/in/jose-%C3%A1ngel-hermosilla-rodrigo-70a590147/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x"
  })])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "primary": "",
      "to": "/index/profile"
    }
  }, [_vm._v("Saber Más")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "primary": "",
      "to": "/index/portfolio"
    }
  }, [_vm._v("Trabajos")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-footer', [_c('div', [_vm._v("© " + _vm._s(new Date().getFullYear()))])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "persistent": "",
      "mini-variant": _vm.miniVariant,
      "clipped": _vm.clipped,
      "enable-resize-watcher": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [(!_vm.miniVariant) ? _c('v-toolbar-title', [_vm._v("Navigation")]) : _vm._e(), _vm._v(" "), (!_vm.miniVariant) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.miniVariant) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.miniVariant) ? _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.drawer = false
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("close")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.items), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "to": item.to,
        "ripple": "",
        "exact": item.exact
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "fixed": "",
      "app": "",
      "clipped-left": _vm.clipped,
      "dark": ""
    }
  }, [(!_vm.drawer) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.miniVariant = !_vm.miniVariant
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clipped = !_vm.clipped
      }
    }
  }, [_c('v-icon', [_vm._v("web")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.fixed = !_vm.fixed
      }
    }
  }, [_c('v-icon', [_vm._v("remove")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('main', [_c('v-content', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-slide-x-transition', [_c('router-view')], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "fixed": _vm.fixed,
      "app": ""
    }
  }, [_c('span', [_vm._v("© 2017")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

module.exports = ["GIS","CAD","IDE","Teledetección","Cartografía","Navegación","GNSS","Geodesia","Catastro","Fotogrametría","WebMapping","Programación","Bases de Datos","..."]

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

module.exports = [{"title":"Grado en Ingeniería Geomática y Topografía","centro":"Universitat Politècnica de València (UPV)","periodo":"2011 - 2016","icon":"school"},{"title":"Máster Geomática y Geoinformación","centro":"Universitat Politècnica de València (UPV)","periodo":"2016 - Actualidad"}]

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = ["NodeJS","ExpressJS","JavaScript","ES6/7","TypeScript","Python","Java","HTML","pug","handlebars","CSS","Stylus","Sass","Android","Ionic 2+","Openlayers 3+","Leaflet","Google Maps","Markdown","git","GitHub","PostgreSQL","PostGIS","Firebase","MongoDB","REST","GraphQL","..."]

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Main__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Content__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Portfolio__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Portfolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Portfolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MarkdownView__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MarkdownView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MarkdownView__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Main___default.a
  }, {
    path: '/index',
    name: 'Content',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Content___default.a,
    children: [{
      path: 'profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Profile___default.a
    }, {
      path: 'portfolio',
      name: 'Portfolio',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Portfolio___default.a
    }, {
      path: 'portfolio/:repoName',
      name: 'Md-Viewer',
      component: __WEBPACK_IMPORTED_MODULE_6__components_MarkdownView___default.a
    }]
  }],
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(67)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(260),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(29);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highlight_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js_styles_androidstudio_css__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js_styles_androidstudio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highlight_js_styles_androidstudio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scroll_into_view__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scroll_into_view__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





var renderer = new __WEBPACK_IMPORTED_MODULE_1_marked___default.a.Renderer();

renderer.heading = function (text, level) {
  return '<h1 id="' + text.toLowerCase().trim().replace(/\:/, '').replace(/ +/g, '-').replace(/[?¿]/g, '') + '">' + text + '</h1>';
};

renderer.link = function (href, title, text) {
  return '<a href="' + href + '" class="m-link">' + text + '</a>';
};

__WEBPACK_IMPORTED_MODULE_1_marked___default.a.setOptions({ renderer: renderer });

var REPO_BASE_URL = function REPO_BASE_URL(repo) {
  return 'https://raw.githubusercontent.com/joseahr/' + repo + '/master/README.md';
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    //VueMarkdown,
  },
  data: function data() {
    return {
      markdown: '',
      notFound: false,
      loading: true,
      fab: false
    };
  },

  methods: {
    getReadme: function getReadme(repo) {
      var _this = this;

      console.log(repo);
      this.$http.get(REPO_BASE_URL(repo)).then(function (res) {
        return res.text();
      }).then(function (markdown) {
        __WEBPACK_IMPORTED_MODULE_1_marked___default()(markdown, { sanitize: true }, function (err, mdParsed) {
          if (err) return;
          _this.markdown = mdParsed;
        });
      }).catch(function (error) {
        if (error.status === 404) {
          _this.notFound = true;
        }
      })
      // Como un finally, catch devuelve una promesa también
      .then(function () {
        _this.loading = false;
      });
    },
    highlight: function highlight() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('pre code')).forEach(function (node) {
        return __WEBPACK_IMPORTED_MODULE_2_highlight_js___default.a.highlightBlock(node);
      });
    },
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      var top = window.pageYOffset || document.documentElement.offsetTop || 0;
      //console.log(top)
      this.fab = top > 300;
    },
    toTop: function toTop() {
      this.$router.push({ hash: '' });
      __WEBPACK_IMPORTED_MODULE_4_scroll_into_view___default()(document.getElementById('scroll-0'), { time: 500 }, function () {
        return window.scrollTo(0, 0);
      });
    }
  },
  created: function created() {
    //console.log(this.$route.params.repoName);
    var repoName = this.$route.params.repoName;

    this.getReadme(repoName);
  },
  mounted: function mounted() {
    this.$vuetify.load(this.onScroll);
    document.getElementById('md-container').addEventListener('click', function (e) {
      if (e.target.classList.contains('m-link')) {
        console.log('clicked', e.target);
        e.preventDefault();
        var href = e.target.getAttribute('href').substring(1);
        //console.log(href)
        var el = document.getElementById(href);
        //console.log(el)
        __WEBPACK_IMPORTED_MODULE_4_scroll_into_view___default()(el, { time: 1000 });
      }
    });
  },
  updated: function updated() {
    this.highlight();
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

var BASE_URL = 'https://api.github.com';
var USER_URL = BASE_URL + '/users/joseahr';
var REPOS_URL = USER_URL + '/repos';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userInfo: null,
      repos: [],
      loading: true,
      isSearching: false,
      search: ''
    };
  },

  watch: {
    isSearching: function isSearching(val) {
      var _this = this;

      this.$refs.toolbar.isScrolling = !val;
      if (val) {
        this.$nextTick(function () {
          _this.$refs.search.focus();
        });
      } else {
        this.search = null;
      }
    },
    search: function search(val) {
      if (!val) {}
    }
  },
  methods: {
    getRepos: function getRepos() {
      var _this2 = this;

      console.log('repos');
      this.$http.get(REPOS_URL).then(function (res) {
        return res.json();
      }).then(function (repos) {
        _this2.repos = repos
        //.filter((repo) => !repo.fork)
        .sort(function (a, b) {
          return new Date(b.updated_at) > new Date(a.updated_at);
        });
      }).catch(console.error).then(function () {
        _this2.loading = false;
      });
    },
    getUserInfo: function getUserInfo() {
      var _this3 = this;

      this.$http.get(USER_URL).then(function (res) {
        return res.json();
      }).then(function (userInfo) {
        _this3.userInfo = userInfo;
      });
    }
  },
  created: function created() {
    this.getRepos();
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__files_tecnologias_json__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__files_tecnologias_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__files_tecnologias_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__files_conocimientos_json__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__files_conocimientos_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__files_conocimientos_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__files_estudios_json__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__files_estudios_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__files_estudios_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tecnologias: __WEBPACK_IMPORTED_MODULE_0__files_tecnologias_json___default.a,
      conocimientos: __WEBPACK_IMPORTED_MODULE_1__files_conocimientos_json___default.a,
      estudios: __WEBPACK_IMPORTED_MODULE_2__files_estudios_json___default.a
    };
  }
});

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      clipped: false,
      fixed: false,
      drawer: false,
      items: [{ icon: 'home', title: 'Home', to: '/', exact: true }, { icon: 'person', title: 'Profile', to: '/index/profile', exact: true }, { icon: 'code', title: 'Portfolio', to: '/index/portfolio', exact: false }],
      miniVariant: false,
      right: true,
      title: 'J. Hermosilla'
    };
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_particles_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_particles_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_particles_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

//const particles = new Particles
var particles = window.particlesJS;
var log = console.log;
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      toolbarVisible: false,
      parallaxHeight: 500
    };
  },

  methods: {
    onScroll: function onScroll() {
      var offsetTop = window.pageYOffset || document.documentElement.scrollTop;
      this.toolbarVisible = offsetTop > 0;
    }
  },
  created: function created() {
    particles.load('banner-welcome', 'static/particles.json', function () {
      return console.log('loaded');
    });
  }
});

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[33]);


// WEBPACK FOOTER //
// static/js/app.aa98360bc275e117783c.js